<p>user-add works!</p>
